import { Component, Input, OnInit, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleTagManagerService } from '../../google-tag-manager/google-tag-manager.service';

@Component({
    selector: 'pw-google-map',
    templateUrl: './google-map.component.html',
    styleUrls: ['./google-map.component.scss']
})
export class GoogleMapComponent implements OnInit {

    @Input() iframeSrc = '';

    constructor(private readonly _domSanitizer: DomSanitizer
    ) {

    }
    ngOnInit(): void {
        this.iframeSrc = this._domSanitizer.bypassSecurityTrustResourceUrl(this.iframeSrc) as string;
    }


}
